import { monolithFetcher } from "src/common/utils/fetching";

/* istanbul ignore next */
export async function logout(): Promise<Response> {
  return monolithFetcher("/logout", { method: "POST", body: JSON.stringify({}) });
}
